import ScrollButtonsLeftRight from "./ScrollButtonsLeftRight";
export default ScrollButtonsLeftRight;